import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import ClientInfoForm from "../../components/clientInfoForm/ClientInfoForm";
import BaseInfoForm from "../../components/baseInfoForm/BaseInfoForm";
import { useStyles } from "./valuationCreator.styles";
import { useFetch } from "../../features/customHooks/useFetch";
import { useNavigate } from "react-router-dom";
import ValuationHistory from "../../components/valuationHistory/ValuationHistory";

const ValuationCreator = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
  const handleHistoryDialogOpen = () => setHistoryDialogOpen(true);
  const handleHistoryDialogClose = () => setHistoryDialogOpen(false);

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const handleConfirmDialogOpen = () => setConfirmDialogOpen(true);
  const handleConfirmDialogClose = () => setConfirmDialogOpen(false);

  const [newFetchState, setNewFetchParams] = useFetch();

  const baseInfoRef = useRef();
  const clientInfoRef = useRef();

  const validate = async () => {
    var baseInfoValid = true;
    var clientInfoValid = true;

    await baseInfoRef?.current?.submit();
    baseInfoValid = baseInfoRef?.current?.isSubmitSuccessful();
    await clientInfoRef?.current?.submit();
    clientInfoValid = clientInfoRef?.current?.isSubmitSuccessful();

    return baseInfoValid && clientInfoValid;
  };

  const handleSubmitForms = async (force) => {
    const valid = await validate();
    console.log(baseInfoRef?.current?.duplications?.length);
    if (valid) {
      if (baseInfoRef?.current?.duplications?.length > 0 && !force) {
        handleConfirmDialogOpen();
      } else {
        const baseInfo = baseInfoRef?.current?.getValues();
        const clientInfo = clientInfoRef?.current?.getValues();
        const allData = { ...baseInfo, ...clientInfo };
        const params = {
          method: "post",
          url: "/valuation",
          data: allData,
        };
        setNewFetchParams(params);
      }
    }
  };

  useEffect(() => {
    if (!newFetchState.loading && !newFetchState.error && newFetchState.data)
      navigate(`../valuations/view/${newFetchState?.data?.data?.id}`);

    if (!newFetchState.loading && newFetchState.error) console.log("error");
  }, [newFetchState]); // eslint-disable-line

  return (
    <Grid container direction='column' className={classes.mainContainer}>
      <Grid container justifyContent='flex-start' alignItems='center'>
        <Typography className={classes.titleTypo}>ایجاد ارزیابی</Typography>
        <Grid container className={classes.formsContainer}>
          <Grid item xs={12}>
            <Grid container className={classes.formContainer}>
              <Grid item xs={12}>
                <Typography className={classes.formBodyTypo}>اطلاعات پایه</Typography>
              </Grid>
              <Grid item xs={12}>
                <BaseInfoForm
                  ref={baseInfoRef}
                  onSubmitForm={() => {}}
                  searchPostalCodeButtonClick={handleHistoryDialogOpen}
                />
              </Grid>
            </Grid>
            <Grid container className={classes.formContainer}>
              <Grid item xs={12}>
                <Typography className={classes.formBodyTypo}>اطلاعات مشتری</Typography>
              </Grid>
              <Grid item xs={12}>
                <ClientInfoForm ref={clientInfoRef} onSubmitForm={() => {}} />
              </Grid>
            </Grid>
          </Grid>
          <Button
            size='medium'
            variant='contained'
            color='primary'
            className={classes.createButton}
            onClick={() => handleSubmitForms(false)}
            disabled={newFetchState?.loading}
          >
            {newFetchState?.loading ? <CircularProgress size={20} /> : "ایجاد ارزیابی"}
          </Button>
        </Grid>
      </Grid>
      <Dialog open={confirmDialogOpen} onClose={handleConfirmDialogClose} maxWidth='xs' fullWidth>
        <DialogTitle>ارزیابی تکراری</DialogTitle>
        <DialogContent>
          <Typography>ارزیابی با کد پستی مشابه وجود دارد، آیا ادامه می‌دهید؟</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleSubmitForms(true)}
            disabled={newFetchState?.loading}
            variant='contained'
            color='primary'
          >
            {newFetchState?.loading ? <CircularProgress size={20} /> : "ایجاد ارزیابی"}
          </Button>
          <Button onClick={handleHistoryDialogOpen}>ارزیابی های مشابه</Button>
          <Button onClick={handleConfirmDialogClose}>بستن</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={historyDialogOpen} onClose={handleHistoryDialogClose} maxWidth='md' fullWidth>
        <DialogTitle>کد پستی مشابه</DialogTitle>
        <DialogContent>
          <ValuationHistory postalCode={baseInfoRef?.current?.getValues()?.postal_code} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleHistoryDialogClose}>بستن</Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default ValuationCreator;
